export default __webpack_public_path__ + "static/maps-Perroquet-2d277f1fc73214f9a8fe40d69bee292d.png";